var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiSearch',_vm._b({attrs:{"url":"bankin/search","columns":_vm.columns,"returnObject":"","placeholder":"Számla hozzáadása","itemText":"combined","notID":"","extraFilter":_vm.filter},on:{"itemSelected":_vm.selected},scopedSlots:_vm._u([{key:"total",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moneyFormat")(item.total,"", 2))+" ")]}}])},'ApiSearch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }